import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { participantsSortStore } from 'state/store';
import { FIXED_PARTICIPANTS_COUNT, MEDIA_BREAKPOINTS } from '../../consts';

export const useGridFixedSlots = (participantsCount: number) => {
    const is16Participants = useMediaQuery({ minWidth: MEDIA_BREAKPOINTS[0], maxWidth: MEDIA_BREAKPOINTS[1] - 1 });
    const is25Participants = useMediaQuery({ minWidth: MEDIA_BREAKPOINTS[1] });

    const fixedSlotsLimit = is25Participants
        ? FIXED_PARTICIPANTS_COUNT[2]
        : is16Participants
        ? FIXED_PARTICIPANTS_COUNT[1]
        : FIXED_PARTICIPANTS_COUNT[0];

    useEffect(() => {
        const fixedSlotsCount = participantsCount < fixedSlotsLimit ? participantsCount : fixedSlotsLimit;

        participantsSortStore.setFixedSlotsCount(fixedSlotsCount);
    }, [participantsCount, fixedSlotsLimit]);
};
